(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-grid-script')
    if (!window.featuredGrids && $url && $url.dataset.designMode !== 'yes') {
      window.featuredGrids = $url.value

      var $script = document.createElement('script')
      $script.src = window.featuredGrids
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["full-screen-zoom-text"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-full-screen-zoom-text-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-and-floating-card"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-and-floating-card-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-cards-pdp-astra"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-cards-script')
    if (!window.imageCards && $url && $url.dataset.designMode !== 'yes') {
      window.imageCards = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageCards
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-cards-script')
    if (!window.imageCards && $url && $url.dataset.designMode !== 'yes') {
      window.imageCards = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageCards
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-sliders"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-sliders-script')
    if (!window.imageSliders && $url && $url.dataset.designMode !== 'yes') {
      window.imageSliders = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageSliders
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"]) return;
  try {
    
  try {
    function getCookie(c_name) {
      if (document.cookie.length > 0) {
        c_start = document.cookie.indexOf(c_name + "=");
        if (c_start != -1) {
          c_start = c_start + c_name.length + 1;
          c_end = document.cookie.indexOf(";", c_start);
          if (c_end == -1) {
            c_end = document.cookie.length;
          }
          return unescape(document.cookie.substring(c_start, c_end));
        }
      }
      return "";
    }

    function loadExclusivePromotion (type) {
      if (type === 'v1') {
        // 显示V1，将V2移除
        var $exclusivePromotionV2 = document.querySelector('product-coupon');
        $exclusivePromotionV2 && $exclusivePromotionV2.remove();
      } else if (type === 'v2') {
        // 显示V2，将V1移除
        var $exclusivePromotionV1 = document.querySelector('.as-exclusive-promotion');
        $exclusivePromotionV1 && $exclusivePromotionV1.remove();
      }
    }

    ;(function() {
      var $enableABTest = document.getElementById('as-enable-exclusive-promotion-abtest');
      var $enableShowOrNotABTest = document.getElementById('as-enable-exclusive-promotion-show-or-not-abtest');
      var AB_NUM_COOKIE = 'abtno';
      var abtno = getCookie(AB_NUM_COOKIE);
      var THRESHOLD = 500; // 50%

      var isTester = (abtno - 0 < THRESHOLD);

      if ($enableABTest != null) {
        if(isTester) {
          loadExclusivePromotion('v2')
        } else {
          loadExclusivePromotion('v1')
        }
      } else if ($enableShowOrNotABTest != null) {
        if(isTester) {
          // 不显示
          var $exclusivePromotionV2 = document.querySelector('product-coupon');
          $exclusivePromotionV2 && $exclusivePromotionV2.remove();
        } else {
          // 显示
        }
      }
    })();
  } catch (error) {
    console.error('Error, error code: Exclusive promotion AB test');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-grid"] && !Shopify.designMode) return;
  try {
    
  const gradientBlock = document.getElementById('gradientBlock');
  const container = document.getElementById('gradientContainer');
  if (gradientBlock == null) return;

  // 页面加载时将色块居中
  function centerGradientBlock() {
    const containerRect = container.getBoundingClientRect();
    const x = (containerRect.width - gradientBlock.offsetWidth) / 2;
    const y = (containerRect.height - gradientBlock.offsetHeight) / 2;
    gradientBlock.style.left = `${x}px`;
    gradientBlock.style.top = `${y}px`;
  }

  // 检查视口大小
  function checkViewportSize() {
    if (window.innerWidth >= 768) {
      // 初始化色块位置
      centerGradientBlock();

      // 处理鼠标移动事件
      document.addEventListener('mousemove', handleMouseMove);
    } else {
      // 移除鼠标移动事件监听器
      document.removeEventListener('mousemove', handleMouseMove);
    }
  }

  // 处理鼠标移动事件
  function handleMouseMove(event) {
    const containerRect = container.getBoundingClientRect();
    const x = event.clientX - containerRect.left - gradientBlock.offsetWidth / 2;
    const y = event.clientY - containerRect.top - gradientBlock.offsetHeight / 2;

    // 限制色块在容器内
    gradientBlock.style.left = `${Math.max(0, Math.min(containerRect.width - gradientBlock.offsetWidth, x))}px`;
    gradientBlock.style.top = `${Math.max(0, Math.min(containerRect.height - gradientBlock.offsetHeight, y))}px`;
  }

  // 初始化视口大小检查
  checkViewportSize();

  // 监听窗口大小变化
  window.addEventListener('resize', checkViewportSize);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-reviews"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-reviews-script')
    if (!window._loadMediaReviews && $url && $url.dataset.designMode !== 'yes') {
      window._loadMediaReviews = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadMediaReviews
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milestone"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-milestone-script')
  if (!window._milestone && $url && $url.dataset.designMode !== 'yes') {
    window._milestone = $url.value

    var $script = document.createElement('script')
    $script.src = window._milestone
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-features-slideshow"] && !Shopify.designMode) return;
  try {
    
  var $featuresSlideshows = document.querySelectorAll('.as-features-slideshow');
  var $navBar = document.querySelector('.as-sticky-nav-bar-pdp');
  var screenHeight = window.innerHeight;
  var navBarHeight = $navBar.clientHeight;
  var visibleHeight = screenHeight - navBarHeight;
  $featuresSlideshows.forEach(function($featuresSlideshow) {
    var top = 0;
    var $mainContent = $featuresSlideshow.querySelector('.as-feature-slideshow-main-content');
    var $scrollContent = $featuresSlideshow.querySelector('.as-horizontal-scroll-container')
    var totalHeight = $mainContent.clientHeight;
    var scrollContentHeight = $scrollContent.clientHeight;
    var mainContentOffsetTop = $mainContent.offsetTop || 0;
    if (totalHeight > visibleHeight) {
      top = (totalHeight - scrollContentHeight + mainContentOffsetTop - navBarHeight) * -1 + (visibleHeight - scrollContentHeight) / 2 + 'px';
    } else {
      top = (visibleHeight - totalHeight) / 2 + navBarHeight - mainContentOffsetTop + 'px';
    }
    $featuresSlideshow.style.setProperty('--top', top);
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-gallery-v2"] && !Shopify.designMode) return;
  try {
    
  var $gallerys = document.querySelectorAll('.as-gallery-v2');
  var galleryWrapper = document.querySelector('.as-gallery-v2-wrapper')
  var enableForcedScrolling = galleryWrapper?.dataset.enableForcedScrolling
  var $navBar = document.querySelector('.as-sticky-nav-bar-pdp');
  var screenHeight = window.innerHeight;
  var navBarHeight = $navBar.clientHeight;
  var visibleHeight = screenHeight - navBarHeight;

  if (enableForcedScrolling === 'true') {
    $gallerys.forEach(function($gallery) {
      var $galleryWrapper = $gallery.querySelector('.as-gallery-v2-wrapper');
      if ($galleryWrapper == null) return;
      var $galleryMainContent = $galleryWrapper.querySelector('.as-gallery-main-content');
      if ($galleryMainContent == null) return;
      var totalHeight = $galleryWrapper.clientHeight;
      var $cardContainer = $galleryWrapper.querySelector('.as-card-container');
      if ($cardContainer == null) return;
      var mainContentOffsetTop = $galleryWrapper.querySelector('.as-card-container').offsetTop;
      var mainContentHeight = $galleryMainContent.clientHeight;
      var top = 0;
      if (totalHeight > visibleHeight) {
        if (mainContentHeight > visibleHeight) {
          top = (mainContentOffsetTop - ((mainContentHeight - visibleHeight) / 2)) * -1 + 'px';
        } else {
          top = (mainContentOffsetTop - ((visibleHeight - mainContentHeight) / 2)) * -1 + 'px';
        }
      } else {
        top = (visibleHeight - totalHeight) / 2 + 'px';
      }
      $gallery.style.setProperty('--top', top);
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-variants-with-video"] && !Shopify.designMode) return;
  try {
    
  try {
    (function() {
      var $varantsWithVideoSection = document.querySelector('.as-variants-with-video');
      if ($varantsWithVideoSection == null) return;
      var $enableABTest = $varantsWithVideoSection.querySelector('.as-enable-abtest');
      var $welcomeVideo = $varantsWithVideoSection.querySelector('.as-welcome-video');
      if ($enableABTest == null || $welcomeVideo == null) {
        return;
      }
      var $pcFlag = document.querySelector('.as-pc-flag');
      if ($pcFlag === null) return;
      var flag = window.getComputedStyle($pcFlag).display === 'none' ? true : false;
      var AB_NUM_COOKIE = 'abtno';
      var abtno = getCookie(AB_NUM_COOKIE);
      var THRESHOLD = 500; // 50%
      var isTester = (abtno - 0 < THRESHOLD);
      if(isTester) {
        loadVideo('v2')
        loadVideoPoster('v2')
      } else {
        loadVideo('v1')
        loadVideoPoster('v1')
      }

      function loadVideo(version) {
        if (version === 'v1') {
          if (flag === true) {
            $welcomeVideo.src = $welcomeVideo.getAttribute('data-desktop-src');
          } else {
            $welcomeVideo.src = $welcomeVideo.getAttribute('data-mob-src');
          }
        } else {
          var v2DesktopSrc = $welcomeVideo.getAttribute('data-version-b-desktop-src');
          var v2mobSrc = $welcomeVideo.getAttribute('data-version-b-mob-src');
          if (flag === true) {
            if (v2DesktopSrc !== '') {
              $welcomeVideo.src = v2DesktopSrc;
            } else {
              directToShowContent();
            }
          } else {
            if (v2mobSrc !== '') {
              $welcomeVideo.src = v2mobSrc;
            } else {
              directToShowContent();
            }
          }
        }
      }

      // AB测试的B版本没有配置视频，直接展示内容
      function directToShowContent() {
        var $content = $varantsWithVideoSection.querySelector('.as-product-info-wrapper');
        var $welcome = $varantsWithVideoSection.querySelector('.as-welcome-wrapper');
        if ($welcome != null) {
          $welcome.style.opacity = 0;
        }
        if ($content != null) {
          $content.style.opacity = 1;
        }
        $welcomeVideo.remove();
      }

      function loadVideoPoster(version) {
        var $videoPoster = $varantsWithVideoSection.querySelector('.as-welcome-video-poster');
        var $template = null;
        if (version === 'v1') {
          $template = $varantsWithVideoSection.querySelector('.as-welcome-video-poster-a');
        } else {
          $template = $varantsWithVideoSection.querySelector('.as-welcome-video-poster-b');
        }
        if ($videoPoster == null || $template == null) return;
        $videoPoster.appendChild($template.content);
      }

      function getCookie(c_name) {
        if (document.cookie.length > 0) {
          c_start = document.cookie.indexOf(c_name + "=");
          if (c_start != -1) {
            c_start = c_start + c_name.length + 1;
            c_end = document.cookie.indexOf(";", c_start);
            if (c_end == -1) {
              c_end = document.cookie.length;
            }
            return unescape(document.cookie.substring(c_start, c_end));
          }
        }
        return "";
      }
    })();
  } catch (error) {
    console.error('Error, error code: FSTABEX');
  }
  try {
    (function () {
      var $varantsWithVideoSection = document.querySelector('.as-variants-with-video');
      if ($varantsWithVideoSection === null) return;
      function calculateForMob () {
        var $imageContainer = $varantsWithVideoSection.querySelector('.as-image-wrapper-container');
        if ($imageContainer != null) {
          var imgContainerHeight = $imageContainer.clientHeight;
          if (imgContainerHeight >= window.innerWidth) {
            var targetWidth = parseInt(308 / 375 * window.innerWidth);
            $varantsWithVideoSection.style.setProperty('--width-for-mob', targetWidth + 'px');
          } else {
            $varantsWithVideoSection.style.setProperty('--width-for-mob', $imageContainer.clientHeight + 'px');
          }
        }
      }
      window.addEventListener('DOMContentLoaded', function () {
        calculateForMob();
      });
      window.addEventListener('resize', function () {
        calculateForMob();
      });
  
      var $enableABTest = $varantsWithVideoSection.querySelector('.as-enable-abtest');
      var $pcFlag = document.querySelector('.as-pc-flag');
      // 开启AB测试，则不执行
      if ($enableABTest != null || $pcFlag === null) return;
      var flag = window.getComputedStyle($pcFlag).display === 'none' ? true : false;
      var $video = $varantsWithVideoSection.querySelector('.as-welcome-video');
      if ($video != null) {
        if (flag === true) {
          $video.src = $video.getAttribute('data-desktop-src');
        } else {
          $video.src = $video.getAttribute('data-mob-src');
        }
      }
    })();
  } catch (error) {
    console.error('Error, load video error (9s pro pdp).');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["primary-product-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-primary-product-cards-script');
    if (!window.primaryProductCards && $url) {
      window.primaryProductCards = $url.value;
      var $script = document.createElement('script');
      $script.src = window.primaryProductCards;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-description-media-reviews"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-reviews-script')
    if (!window._loadMediaReviews && $url && $url.dataset.designMode !== 'yes') {
      window._loadMediaReviews = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadMediaReviews
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stairs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-stairs-script')
    if (!window._stairs && $url && $url.dataset.designMode !== 'yes') {
      window._stairs = $url.value

      var $script = document.createElement('script')
      $script.src = window._stairs
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-testimonials-script')
    if (!window._loadSwiper && $url && $url.dataset.designMode !== 'yes') {
      window._loadSwiper = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadSwiper
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["title-with-image-stairs-for-10air"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-title-with-image-stairs-script')
    if (!window._gsapCreative && $url) {
      window._gsapCreative = $url.value

      var $script = document.createElement('script')
      $script.src = window._gsapCreative
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["title-with-image-stairs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-title-with-image-stairs-script')
    if (!window._gsapCreative && $url) {
      window._gsapCreative = $url.value

      var $script = document.createElement('script')
      $script.src = window._gsapCreative
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["title-with-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-title-with-tab-script')
    if (!window._gsapCreative && $url) {
      window._gsapCreative = $url.value

      var $script = document.createElement('script')
      $script.src = window._gsapCreative
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();
})();
